<template>
    <div class="precisionSearch">
        <viewHeader></viewHeader>
        <div class="content">
            <el-card class="box-card" shadow="never">
                <div class="searchKey">
                    <h2><span>精准搜索</span></h2>
                    <div class="searchInfo clearfix">
                        <p class="clearfix">
                            <el-link type="danger" class="R" @click="keywordBox = [{ 'value': '' }]">全部清除</el-link>
                        </p>
                        <el-row :gutter="20" class="keyBox" v-for="(item, index) in keywordBox" :key="index">
                            <el-col :span="3" v-if="index !== 0">
                                <el-select v-model="item.options_value" placeholder="请选择" class="L" size=
                                "small" style="width:80px">
                                    <el-option
                                        v-for="item in options"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-col>
                            <el-col :span="11" :offset="index === 0 ? 3 : 0">
                                <el-input
                                    class="L"
                                    size="small"
                                    v-model="item.value"
                                    placeholder="请输入关键词"
                                    clearable>
                                </el-input>
                            </el-col>
                            <el-col :span="1">
                                <i class="el-icon-circle-plus-outline" @click="addKey(index)"></i>
                            </el-col>
                            <el-col :span="2" v-if="index !== 0">
                                <i class="el-icon-remove-outline" @click="deleteKey(index)"></i>
                            </el-col>
                            <el-col :span="4" :offset="index === 0 ? 2 : 0">
                                <el-button type="primary" size="small" @click="getUpDownKey(item.value, index)">上下位关键词</el-button>
                            </el-col>
                            <el-col :span="3">
                                <el-button type="primary" size="small" @click="getrelatedKey(item.value, index)">相关关键词</el-button>
                            </el-col>
                        </el-row>
                    </div>
                    <div class="searchBtn">
                        <el-button type="primary" size="small" @click="search">搜 索</el-button>
                        <!-- <el-link type="primary" @click="addHistory">加入历史记录</el-link> -->
                    </div>
                </div>
                <div class="searchKey historyTable">
                    <h2><span>历史记录</span></h2>
                    <div class="searchInfo clearfix">
                        <p class="clearfix">
                            <el-link type="danger" class="R" @click="deleteHistory">删除</el-link>
                        </p>
                        <el-table
                            ref="multipleTable"
                            :data="tableData"
                            tooltip-effect="dark"
                            style="width: 100%"
                            :stripe="true"
                            :border="true"
                            @selection-change="handleSelectionChange">
                            <el-table-column type="selection">
                            </el-table-column>
                            <el-table-column
                                prop="update_time"
                                label="时间"
                                >
                                <template slot-scope="scope">{{ scope.row.update_time }}</template>
                            </el-table-column>
                            <el-table-column
                                prop="keyword"
                                label="搜索内容"
                                width="300px"
                                >
                                <!-- <template slot-scope="scope">
                                    <span v-for="(item, index) in scope.row.keyword" :key="index" :style="item !== '并且' && item !== '或者' && item !== '排除' ? 'color: #387ed2' : '#333'"> {{ item }} </span>
                                </template> -->
                                <template slot-scope="scope">
                                    <span v-for="(item, index) in scope.row.keyword" :key="index" :style="item !== 'AND' && item !== 'OR' && item !== 'NOT' ? 'color: #387ed2' : '#333'"> {{ item }} </span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                label="操作"
                                show-overflow-tooltip>
                                <el-link type="primary" slot-scope="scope" 
                                @click="addSearch(scope.row.keyword)">加入搜索</el-link>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
                <el-pagination
                    background
                    :hide-on-single-page="true"
                    :current-page="pageNum"
                    :page-size="10"
                    @current-change="handleCurrentChange"
                    layout="prev, pager, next"
                    :total="totalNum">
                </el-pagination>
            </el-card>
        </div>
        <el-dialog
            :title="keyName"
            :visible.sync="centerDialogVisible"
            width="30%"
            center>
            <div class="keyList">
                <h3>关键词</h3>
                <div class="list">
                    <el-radio-group v-model="upDownKey">
                        <el-radio :label="item" v-for="(item, index) in upDownKeyArrary" :key="index">{{ item }}</el-radio>
                    </el-radio-group>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="centerDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="chooseKey">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import _ from 'lodash'
import viewHeader from './viewHeader'
import { upDownKey, relatedKey, getHistory, deleteHistory } from '../service/getData'
import { webTrackerEvent } from '../utils/tracker'
export default {
    name: 'precisionSearch',
    components: {
        viewHeader
    },
    data () {
        return {
            loading: false,
            options: [
                {
                'value': '并且',
                'label': '并且'
                },{
                'value': '排除',
                'label': '排除'
                },{
                'value': '或者',
                'label': '或者'
                },
            ],
            centerDialogVisible: false, // 上下位关键词弹框
            tableData: [], // 历史记录数据
            keywordBox: [{ 'value': '' }], // 精准搜索的关键词
            multipleSelection: [],
            upDownKeyArrary: [], // 上下位关键词
            upDownKey: '', // 选中的关键词
            relatedKeyArrary: [], // 相关关键词
            keyName: '',
            keywordIndex: 0, // 替换的关键词输入框的索引
            pageNum: 1,
            pageSize: 10,
            totalNum: 0,
            hisId: 0, // 设置历史记录每一条的id
            token: window.localStorage.getItem('PUBMEDSEARCHTOKEN'),
            openid: window.localStorage.getItem('PUBMEDSEARCHOPENID')
        }
    },
    methods: {
        handleSelectionChange(val) {
            this.multipleSelection = []
            val.forEach((item, index) => {
                this.multipleSelection.push(item.id)
            })
        },
        // 获取上下位关键词
        async getUpDownKey(keyword, index) {
            if (keyword === '') {
                this.$message({
                    message: '请输入关键词',
                    type: 'warning'
                })
                return
            }
            this.keywordIndex = index
            const params = { 'keyword': keyword }
            const res = await upDownKey(params)
            if (res.data.status === 0) {
                this.keyName = '上下位关键词'
                this.upDownKey = ''
                this.centerDialogVisible = true
                this.upDownKeyArrary = [...res.data.child, ...res.data.parent]
            } else {
                this.$alert(res.data.msg, '标题名称', {
                    confirmButtonText: '确定',
                })
            }
        },
        // 获取相关关键词
        async getrelatedKey(keyword, index) {
            if (keyword === '') {
                this.$message({
                    message: '请输入关键词',
                    type: 'warning'
                })
                return
            }
            this.keywordIndex = index
            const params = { 'keyword': keyword }
            const res = await relatedKey(params)
            if (res.data.status === 0) {
                this.keyName = '相关关键词'
                this.upDownKey = ''
                this.centerDialogVisible = true
                this.upDownKeyArrary = res.data.concurrence
            } else {
                this.$alert(res.data.msg, '标题名称', {
                    confirmButtonText: '确定',
                })
            }
        },
        // 替换关键词（上下位关键词）
        chooseKey() {
            if (this.upDownKey === '') {
                this.$message({
                    message: '请选择要替换的关键词',
                    type: 'warning'
                })
                return
            }
            if (this.keyName === '相关关键词') {
                const add_key = { 'value': this.upDownKey, 'options_value': '并且' }
                this.keywordBox.splice(this.keywordIndex + 1, 0, add_key)
            } else {
                this.$set(this.keywordBox[this.keywordIndex], 'value', this.upDownKey)
            }
            this.centerDialogVisible = false
        },
        // 获取历史记录
        async getHistory() {
            const params = { 'limit': this.pageSize, 'page': this.pageNum }
            const res = await getHistory(params)
            if (res.data.status === 0) {
                if (res.data.data.length !== 0) {
                }
                this.totalNum = res.data.count
                res.data.data.forEach(item => {
                    item.update_time = item.update_time.substring(0, 10)
                })
                this.tableData = res.data.data
            }
        },
        // 添加一行关键词
        addKey(index) {
            const add_key = { 'value': '', 'options_value': '并且' }
            this.keywordBox.splice(index+1, 0, add_key)
        },

        // 删除一行关键词
        deleteKey(key_index) {
            const filter = this.keywordBox.filter(function(value, index, arr){
                if (key_index !== index) {
                    return value
                }
            })
            this.keywordBox = filter
            // this.keywordBox.splice(index, 1)
        },
        // 开始精准搜索
        search() {
            let isFill = true
            const advance_key_word = [] // 拼接要搜索的关键词
            let connect_word = '' 
            this.keywordBox.forEach(item => {
                if (item.value === '') {
                    isFill = false
                    return
                }
            })
            if (!isFill) {
                this.$alert('请输入所有要搜索的关键词', '标题名称', {
                    confirmButtonText: '确定',
                })
                return
            }
            this.keywordBox.forEach((item, index) => {
                if (index !== 0) {
                    if (item.options_value === '并且') {
                        connect_word = 'AND'
                        advance_key_word.push(connect_word)
                    } else if (item.options_value === '或者') {
                        connect_word = 'OR'
                        advance_key_word.push(connect_word)
                    } else if (item.options_value === '排除') {
                        connect_word = 'NOT'
                        advance_key_word.push(connect_word)
                    }
                }
                advance_key_word.push(item.value)
            })
            const { href } = this.$router.resolve({
                name: 'baseResult',
                path: '/baseResult',
                query: { 'key': advance_key_word, 'searchType': 'advanced'}
            })

            let Logger = webTrackerEvent()
            Logger.push('page_url', window.location.href);
            Logger.push('action', 'search');
            Logger.push('search_type', 'precise');
            Logger.push('search_keyword', advance_key_word);
            Logger.push('token', this.token);
            Logger.push('openid', this.openid);
            Logger.logger()

            window.open(href)
        },
        // 补0
        isZero(n) {
            return n < 10 ? '0' + n : '' + n
        },
        // 加入历史记录（已弃用）
        addHistory() {
            let isFill = true
            const advance_key_word = [] // 拼接要搜索的关键词
            let connect_word = '' 
            this.keywordBox.forEach(item => {
                if (item.value === '') {
                    isFill = false
                    return
                }
            })
            if (!isFill) {
                this.$alert('请输入所有要搜索的关键词', '标题名称', {
                    confirmButtonText: '确定',
                })
                return
            }
            this.keywordBox.forEach((item, index) => {
                if (index !== 0) {
                    advance_key_word.push(item.options_value)
                }
                advance_key_word.push(item.value)
            })
            const origin_key = _.cloneDeep(this.keywordBox)
            const oDate = new Date()
            const hours = oDate.getHours()
            const minutes = oDate.getMinutes()
            const seconds = oDate.getSeconds()
            const time = this.isZero(hours) + ':' + this.isZero(minutes) + ':' + this.isZero(seconds)
            this.hisId ++
            this.tableData.push({ 'id': this.hisId, 'update_time': time, 'keyword': advance_key_word, 'origin': origin_key })
        },
        // 加入搜索
        addSearch(keyword) {
            // console.log(keyword)
            let key_arr = []
            let new_key_arr = []
            let connect_val = '' // 连接词

            // 把原始数组分割成2个一组的数组
            if (keyword.length > 1) {
                key_arr.push(keyword[0])
                for(var i = 1,len = keyword.length;i < len;i += 2){
                    key_arr.push(keyword.slice(i,i+2))
                }
            } else {
                key_arr = keyword
            }
            
            key_arr.forEach((item, index) => {
                if (index === 0) {
                    new_key_arr.push({ 'value': item })
                } else {
                    if (item[0] === 'AND') {
                        connect_val = '并且'
                    } else if (item[0] === 'OR') {
                        connect_val = '或者'
                    } else if (item[0] === 'NOT') {
                        connect_val = '排除'
                    }
                    new_key_arr.push({ 'options_value': connect_val, 'value': item[1] })
                }
            })
            this.keywordBox = new_key_arr
        },
        // 删除历史记录
        async deleteHistory() {
            if (this.multipleSelection.length === 0) {
                this.$alert('请选择要删除的内容', '标题名称', {
                    confirmButtonText: '确定',
                })
                return
            }
            // const _this = this
            // this.multipleSelection.filter(function(value, index, arr) {
            //     _this.tableData.forEach((item, index1) => {
            //         if (item.id === value) {
            //             _this.tableData.splice(index1, 1)
            //         }
            //     })
            // })
            const params = { 'ids': this.multipleSelection}
            const res = await deleteHistory(params)
            if (res.data.status === 0) {
                this.$message({
                    message: '删除成功',
                    type: 'success'
                })
                this.getHistory()
            } else {
                this.$message.error('删除失败，请稍后重试')
            }
        },
        // 分页 （未用）
        handleCurrentChange(val) {
            this.pageNum = val
            this.getHistory()
        },
    },
    mounted() {
        this.getHistory()
    }
}
</script>

<style scoped>
    .precisionSearch{
        background:#f9f9f9;
        padding-bottom: 50px
    }
    .precisionSearch .content{
        width: 1080px;
        margin:0 auto
    }
    .precisionSearch .content .searchKey{
        width:900px;
        margin:0 auto
    }
    .precisionSearch .content .searchKey h2{
        border-bottom: 1px solid #387ed2;
        padding-bottom: 6px;
        font-weight: normal
    }
    .precisionSearch .content .searchKey h2 span{
        font-size: 16px;
        color:#333;
        border-bottom: 4px solid #387ed2;
        padding-bottom: 4px
    }
    .precisionSearch .content .searchInfo{
        font-size: 14px;
        color: #333;
        width:760px;
        margin:0 auto;
        margin-top:30px;
    }
    .precisionSearch .content .el-icon-circle-plus-outline{
        font-size: 18px;
        line-height: 32px;
        cursor: pointer;
    }
    .precisionSearch .content .el-icon-remove-outline{
        font-size: 18px;
        line-height: 32px;
        cursor: pointer;
    }
    .precisionSearch .content .keyBox{
        margin-top:10px
    }
    .precisionSearch .content .keyBox button{
       background:#2aa3d1
    }
    .precisionSearch .content .searchBtn{
        width:240px;
        margin:0 auto;
        margin-top:50px;
    }
    .precisionSearch .content .searchBtn button{
        width:120px;
        height:36px;
        font-size: 16px;
        background:#387ed2;
        border-radius: 10px;
    }
    .precisionSearch .content .searchBtn a{
        margin-left: 10px
    }
    .precisionSearch .content .historyTable{
        margin-top:50px;
    }
    .precisionSearch .content .historyTable .el-table{
        margin-top:10px;
    }
    .precisionSearch .el-dialog__wrapper .keyList{
        border:1px solid #ddd
    }
    .precisionSearch .el-dialog__wrapper .keyList h3{
        text-align: center;
        font-size: 14px;
        color:#333;
        padding:5px 0;
        background:#e7f2ff
    }
    .precisionSearch .el-dialog__wrapper .keyList div.list{
        max-height:300px;
        overflow: scroll
    }
    .precisionSearch .el-dialog__wrapper .keyList .el-radio-group{
        width:100%;
        overflow: hidden;
    }
    .precisionSearch .el-dialog__wrapper .keyList label{
        display: block;
        padding: 10px 0;
        border-top:1px solid #ddd;
        width:100%;
        font-size: 12px;
        padding-left: 30px;
    }
    .precisionSearch .el-dialog__wrapper .el-dialog__footer button{
        padding:8px 30px
    }
    .precisionSearch .el-dialog__wrapper .el-dialog__footer button.el-button+.el-button{
        margin-left: 40px
    }
    .precisionSearch .el-pagination{
        margin-top:30px;
        text-align: center
    }
</style>
<style>
    .precisionSearch .el-table th.is-leaf{
        background-color:#f8f8f8
    }
    .precisionSearch .el-dialog__wrapper .el-dialog{
        border-radius: 10px;
    }
</style>


// WEBPACK FOOTER //
// src/views/precisionSearch.vue